const errorTypes = {
	KEYNOTSPECIFIED: 'KEYNOTSPECIFIED',
	NOTFOUND: 'NOTFOUND',
	INVALIDOBJECT: 'INVALIDOBJECT',
	UNKNOWNERROR: 'UNKNOWNERROR',
	LOCALISEDERROR: 'LOCALISEDERROR'
}

export default errorTypes



// WEBPACK FOOTER //
// ./src/enums/errorTypes.js